import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';

import {usePanel} from '../../app/PanelProvider.js';

export const leadQueryKey = (pseudonym: string) =>
  ['leads', 'conversation', pseudonym] as const;

/**
 * O detalhe de uma conversa, por pseudônimo.
 *
 * A chave do cache é o pseudônimo, e não um índice de lista: duas conversas
 * abertas em sequência não podem compartilhar entrada de cache, senão a segunda
 * mostraria o estado da primeira por um quadro, que numa tela de dado pessoal é
 * mostrar a conversa errada para a pessoa errada.
 */
export const useLeadConversation = (pseudonym: string) => {
  const {dataSource} = usePanel();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: leadQueryKey(pseudonym),
    queryFn: ({signal}) => dataSource.getLeadConversation(pseudonym, signal),
  });

  const refresh = useCallback(() => {
    void queryClient.invalidateQueries({queryKey: leadQueryKey(pseudonym)});
  }, [pseudonym, queryClient]);

  return {...query, refresh};
};
